module.exports = __webpack_public_path__ + "img/preview-10.5eba0d28.png";